import React, { createContext, useState, useContext } from 'react';

const SurveyContext = createContext();

export const useSurvey = () => useContext(SurveyContext);

export const SurveyProvider = ({ children }) => {
  const [diagnosticName, setDiagnosticName] = useState('');
  const [participantes, setParticipantes] = useState([]);
  const [questions, setQuestions] = useState([
    { id: 1, configured: false },
    { id: 2, configured: false },
    { id: 3, configured: false },
  ]);
  // Nuevo estado para almacenar la imagen
  const [diagnosticImage, setDiagnosticImage] = useState(null);
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');

  const updateFechaInicio = (fecha) => {
    setFechaInicio(fecha);
  };

  const updateFechaFin = (fecha) => {
    setFechaFin(fecha);
  };



  const updateParticipantes = (newParticipantes) => {
    setParticipantes(newParticipantes);
  };

  // Función para actualizar la imagen del diagnóstico
  const updateDiagnosticImage = (image) => {
    setDiagnosticImage(image);
  };

  return (
    <SurveyContext.Provider
      value={{
        diagnosticName,
        setDiagnosticName,
        questions,
        setQuestions,
        diagnosticImage, // Añade la imagen como parte del contexto
        updateDiagnosticImage, // Función para actualizar la imagen
        participantes, 
        updateParticipantes,
        fechaInicio,
        updateFechaInicio,
        fechaFin,
        updateFechaFin, 
      }}
    >
      {children}
    </SurveyContext.Provider>
  );
};